import { CompanyDetailAndJobGroups } from '@types';
import { useSidebarItems } from './sidebar-items';

export const filterOutSidebarItems = ({
  sidebarItems,
  company,
  allowWorkflows,
  allowCollegialLending,
  companyRoles,
}: {
  sidebarItems: ReturnType<typeof useSidebarItems>;
  company: CompanyDetailAndJobGroups | undefined;
  allowWorkflows: boolean;
  allowCollegialLending: boolean;
  companyRoles: string[] | undefined;
}) => {
  const hasCompanyRoles = !!companyRoles?.length;
  const isHqAdmin = companyRoles?.includes('HQADMIN');
  const isAdmin = companyRoles?.includes('ADMIN');
  const isAnyAdmin = isHqAdmin || isAdmin;

  const offersEmployeeWork = company?.company.offersEmployeeWork;

  // shallow copy to avoid mutating original sidebar config
  const result = sidebarItems.map((section) => ({
    ...section,
    children: [...section.children],
  }));

  const getSection = (key: string) => result.find((s) => s.key === key);

  const filterSectionChildren = (key: string, predicate: (item: { path: string }) => boolean) => {
    const section = getSection(key);
    if (section) {
      section.children = section.children.filter(predicate);
    }
  };

  if (!offersEmployeeWork) {
    filterSectionChildren('workforce-management', (item) => item.path !== 'management/workforce');
  }

  if (!hasCompanyRoles || !isAnyAdmin) {
    filterSectionChildren('management', (item) => item.path !== 'settings');
  }

  if (!hasCompanyRoles || !isHqAdmin || !allowWorkflows) {
    filterSectionChildren('management', (item) => item.path !== 'management/workflows');
  }

  if (!allowCollegialLending) {
    return result.filter(
      (section) => section.key !== 'client-management' && section.key !== 'supplier-management'
    );
  }

  return result;
};
